<template>
  <div>
    <Jumbotron title="Guider Terms &amp; Condition" />

    <b-container class="text-justify pt-3">
      <b-row>
        <b-col>
          <p>
            STARGUIDES menjunjung tinggi kode etik sehingga semua Mitra wajib memiliki pemahaman yang jelas tentang hukum standar kepatuhan, keselamatan, keamanan dan pelayanan yang diharapkan dari Mitra. Karena STARGUIDES mempertahankan kebijakan tanpa toleransi, pelanggaran dapat mengakibatkan penangguhan atau penghentian akses pengguna situs web www.starguides.co.
          </p>

          <p>
            <b>Setiap Mitra STARGUIDES setuju untuk mematuhi sepenuhnya dengan kode etik ini.</b>
          </p>

          <p>
            1.  MEMATUHI SEMUA HUKUM, PERATURAN, KEBIJAKAN DAN PEDOMAN
          </p>

          <p>
            <ol type="a">
              <li>Setiap Mitra Wajib memakai Scarf STARGUIDES sebagai identitas.</li>
              <li>Setiap Mitra diwajibkan membeli Scarf STARGUIDES sebesar Rp. 310.000 (€ 20, sesuai dengan kurs pada saat waktu anda bertransaksi).</li>
              <li>Jika Pelanggan mengalami kehilangan barang/passport, sebisa mungkin Mitra proses untuk membuatkan laporan kepada polisi setempat di negara yang dikunjungi dan akan membantu membuat SPLP (Surat Perjalanan Laksana Passpor) di Kedutaan Besar Republik Indonesia.</li>
              <li>Mitra wajib mengganti tanggal <i>availability</i> (ketersediaan) jika ada perbuahan.</li>
              <li>Mitra akan kami anggap Online dan akan kami berikan notifikasi sesuai tanggal yang telah di pilih.</li>
              <li>STARGUIDES berhak menarik 10% dari keuntungan Mitra bila ada promosi dengan tujuan akan meningkatkan pelanggan ke negara yang akan di kunjungi.</li>
              <li>Mitra Wajib memasukan data diri ke dalam system STARGUIDES seperti : Passport, Visa, KTP, Sertifikat Bahasa & Asuransi.</li>
              <li>Mitra secara ketat dilarang menghubungi <i>Customers</i> melalui saluran atau platform secara langsung kecuali lewat ruang diskusi yang sudah dibuat terlebih dahulu dan untuk tujuan kerja.</li>
              <li>Tekan ‘START GUIDE’ / ‘STOP GUIDE’ hanya setelah <i>Customers</i> telah datang atau dan meninggalkan lokasi.</li>
              <li>Mitra harus mematuhi semua peraturan lalu lintas, peraturan, aturan, kebijakan dan pedoman serta Kode Etik ini dan pedoman lebih lanjut yang mungkin dikeluarkan oleh STARGUIDES dari waktu ke waktu.</li>
              <li>Mitra setuju untuk tidak terlibat dalam aktivitas apapun yang dapat mengganggu atau menurunkan reputasi STARGUIDES dan / atau menyebabkan gangguan untuk operasi STARGUIDES atau bersekongkol dengan Mitra lain atau pihak ketiga dengan maksud untuk melakukan tindakan tersebut di atas.</li>
              <li>STARGUIDES mempertahankan kebijakan tanpa toleransi mengenai semua pelanggaran dan dapat mengakibatkan suspensi atau penghentian akses pengguna STARGUIDES.</li>
              <li>STARGUIDES melakukan yang terbaik untuk memberikan pelayanan.</li>
              <li>Mitra dilarang keras terhadap melakukan setiap tindakan dengan maksud untuk curang atau menipu.</li>
              <li>Mitra dilarang mengambil bagian dalam demonstrasi ilegal terhadap STARGUIDES, menjadi anggota asosiasi terdaftar, menghasut Mitra lain untuk tidak menggunakan layanan STARGUIDES, boikot atau mengancam untuk memboikot Situs Web STARGUIDES atau tindakan lain yang dapat ditafsirkan untuk melawan kepentingan STARGUIDES.</li>
            </ol>
          </p>

          <p>
            2.  PROFESIONAL DAN KUALITAS PELAYANAN
          </p>

          <p>
            <ol type="a">
              <li>Mitra harus menyediakan layanan/transportasi yang aman bagi semua <i>Customers</i>. Keselamatan <i>Customers</i> dan Mitra pada platform STARGUIDES menjadi perhatian sepenuhnya.</li>
              <li>STARGUIDES tidak mentolerir konsumsi setiap obat atau alkohol dengan Mitra saat menggunakan Situs Website STARGUIDES. Ini adalah melawan hukum dan pelanggaran serius terhadap kebijakan keselamatan STARGUIDES ini. Selanjutnya, zat ilegal dan wadah terbuka alkohol tidak diizinkan di kendaraan STARROAD ‘. Jika penumpang percaya sopir mungkin berada di bawah pengaruh obat-obatan atau alkohol, ia memiliki hak untuk mengakhiri perjalanan segera dan layanan pelanggan waspada.</li>
              <li>Mitra dilarang memiliki atau menyimpan senjata jenis atau deskripsi apapun untuk alasan apapun.</li>
              <li>
                STARGUIDES mengambil pandangan yang serius pada mengemudi STARROAD yang membahayakan penumpang dan / atau pengguna jalan lainnya dan ini termasuk:
                <ul>
                  <li>Mengemudi melawan arah.</li>
                  <li>Gagal mematuhi batas kecepatan.</li>
                  <li>Gagal untuk menyesuaikan diri dengan lampu lalu lintas.</li>
                  <li>Menggunakan ponsel tanpa hands free saat mengemudi.</li>
                  <li>Gagal menggunakan sinyal indikator sebelum mengubah atau berubah menjadi persimpangan.</li>
                  <li>Melanggar hukum lalu lintas lainnya.</li>
                </ul>
              </li>
              <li>Mitra harus menjalani pemeriksaan kesehatan fisik secara teratur sebagaimana diamanatkan atau direkomendasikan oleh peraturan  sebagai dan ketika diarahkan oleh STARGUIDES.</li>
              <li>Mitra harus selalu benar dan sopan berpakaian dan menunjukkan perangai yang baik serta berkomunikasi dengan penumpang dengan sopan.</li>
              <li>Mitra STARROAD dilarang mengemudi tanpa lisensi, polisi asuransi yang valid dan / atau izin usaha atau izin yang diperlukan untuk menyediakan transportasi untuk menyewa.</li>
              <li>Mitra secara ketat dilarang melakukan segala bentuk pelanggaran seksual, termasuk membuat cabul komentar / teks, pelecehan seksual, kontak fisik yang tidak diinginkan, menahan diri melanggar hukum, membius, penganiayaan dan pemerkosaan. Ini adalah tindak pidana di bawah hukum dan pelanggaran serius terhadap kebijakan keselamatan STARGUIDES ini. Pelanggar akan dituntut melawan hukum.</li>
              <li>Mitra tidak akan menolak untuk memberikan layanan berdasarkan ras seseorang, agama, asal negara, cacat, orientasi seksual, jenis kelamin, status perkawinan, jenis kelamin, usia atau karakteristik lain yang dilindungi di bawah hukum. jenis perilaku dapat mengakibatkan penghentian akses pengguna ke platform yang STARGUIDES. Hal ini tidak sopan untuk membuat komentar yang menghina, atau diskriminatif tentang seseorang atau kelompok, apakah penumpang milik kelompok.</li>
              <li>Mitra dilarang keluar negara atau mengaktifkan layanan STARTRIP Bila Visa/Passport atau identitas lainnya valid kurang dari 6 bulan.</li>
              <li>Jangan menetapkan tarif sendiri (Charge misalnya per perjalanan) karena hal ini dapat dianggap sebagai berlebihan dan melanggar dari aturan STARGUIDES.</li>
              <li><i>Customers</i> menghargai kejujuran pada bagian Mitra. Oleh karena itu, Mitra akan memberikan layanan yang didasarkan pada prinsip ini.</li>
            </ol>
          </p>
        </b-col>
      </b-row>
    </b-container>

    <b-container class="mt-5" />
  </div>
</template>

<script>
import Jumbotron from '@/components/Jumbotron'

export default {
  name: 'TermsAndConditionGuider',
  components: {
    'Jumbotron': Jumbotron
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Static/TermsAndConditionGuider.vue